import type { OptionType } from '@innovamat/glimmer-components';

import type { StandardContent } from '@innovamat/resource-viewer';
import type { ContentBlockTag, StandardTag } from '../types/SmartGuide';

const isBlock = (value: string) => {
  const regex = /^block_/;
  return regex.test(value);
};

const getStandardBlocks = (
  standardContent: StandardContent[]
): ContentBlockTag[] => {
  return standardContent
    ?.filter((standard) => isBlock(standard.blockKey))
    .map((standard) => ({
      textKey: standard.blockKey,
      isEnabled: true,
    }));
};

const hasContentBlocks = (standardContent: StandardContent[]): boolean => {
  return standardContent?.every((standard) => isBlock(standard.blockKey));
};

const getStandardTags = (standardContent: StandardContent[]): StandardTag[] => {
  return standardContent
    ?.filter((standard) => !isBlock(standard.blockKey))
    .flatMap((standard) => standard.content)
    .map((content) => ({
      text: content.contentValue,
      tooltipKey: content.contentKey,
      isSupporting: !content.mainStandard,
    }))
    .sort((a, b) => Number(a.isSupporting) - Number(b.isSupporting));
};

const standards: OptionType[] = [
  { value: 'BUBBLE_TREE', label: 'Bubble Tree' },
  { value: 'COMMON_CORE', label: 'Common Core' },
  { value: 'NEW_JERSEY', label: 'New Jersey' },
  { value: 'WEST_VIRGINIA', label: 'West Virginia' },
  { value: 'PENNSYLVANIA', label: 'Pennsylvania' },
  { value: 'CALIFORNIA', label: 'California' },
  { value: 'ILLINOIS', label: 'Illinois' },
  { value: 'QA_STANDARD', label: 'QA_STANDARD' },
];

const isCommonCoreStandard = (standard: string): boolean =>
  standard === 'COMMON_CORE';

const isNewJerseyStandard = (standard: string): boolean =>
  standard === 'NEW_JERSEY';

const isPennsylvaniaStandard = (standard: string): boolean =>
  standard === 'PENNSYLVANIA';

const isWestVirginiaStandard = (standard: string): boolean =>
  standard === 'WEST_VIRGINIA';

const isValidatedUSStandard = (standard: string): boolean =>
  isCommonCoreStandard(standard) ||
  isNewJerseyStandard(standard) ||
  isPennsylvaniaStandard(standard) ||
  isWestVirginiaStandard(standard);

export {
  getStandardBlocks,
  getStandardTags,
  hasContentBlocks,
  isValidatedUSStandard,
  standards,
};
